/**
 * Post Content Image Fallback Setup
 *
 * Initializes fallback image handling for post content images.
 */

import { PostContentImageFallbackRender } from "./post-content-image-fallback-render";
import { PostContentImageFallbackHandler } from "./post-content-image-fallback-handler";
import { PostContentImageFallbackListener } from "./post-content-image-fallback-listener";

const INIT_FLAG = "postContentImageFallbackInit";

class PostContentImageFallbackSetup {
    public static init(): void {
        const root = document.documentElement;
        if (!(root instanceof HTMLElement)) return;
        if (root.dataset[INIT_FLAG] === "1") return;
        root.dataset[INIT_FLAG] = "1";

        const render = new PostContentImageFallbackRender();
        const handler = new PostContentImageFallbackHandler(render);

        PostContentImageFallbackListener.bindDocumentImageError((event: Event) => {
            const target = event.target instanceof Element ? event.target : null;
            if (!(target instanceof HTMLImageElement)) return;

            handler.handleImageError(target);
        });

        handler.scanBrokenImages(document);
    }
}

export { PostContentImageFallbackSetup };
